var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 17,
  viewBox: "0 0 17 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 16,
  height: 16,
  rx: 8,
  fill: "none",
  stroke: "#4A148C"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.5 11.1194L3.875 8.29851L3 9.23881L6.5 13L14 4.9403L13.125 4L6.5 11.1194Z",
  fill: "#4A148C"
})));
export default SvgCheckCircle;